import { render, staticRenderFns } from "./TableStructure.vue?vue&type=template&id=62187bc3&scoped=true"
import script from "./TableStructure.vue?vue&type=script&lang=js"
export * from "./TableStructure.vue?vue&type=script&lang=js"
import style0 from "./TableStructure.vue?vue&type=style&index=0&id=62187bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62187bc3",
  null
  
)

export default component.exports